var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_471_581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49992 1.8335C4.81992 1.8335 1.83325 4.82016 1.83325 8.50016C1.83325 12.1802 4.81992 15.1668 8.49992 15.1668C12.1799 15.1668 15.1666 12.1802 15.1666 8.50016C15.1666 4.82016 12.1799 1.8335 8.49992 1.8335ZM7.83325 13.7868C5.19992 13.4602 3.16659 11.2202 3.16659 8.50016C3.16659 8.08683 3.21992 7.6935 3.30659 7.30683L6.49992 10.5002V11.1668C6.49992 11.9002 7.09992 12.5002 7.83325 12.5002V13.7868ZM12.4333 12.0935C12.2599 11.5535 11.7666 11.1668 11.1666 11.1668H10.4999V9.16683C10.4999 8.80016 10.1999 8.50016 9.83325 8.50016H5.83325V7.16683H7.16659C7.53325 7.16683 7.83325 6.86683 7.83325 6.50016V5.16683H9.16659C9.89992 5.16683 10.4999 4.56683 10.4999 3.8335V3.56016C12.4533 4.3535 13.8333 6.26683 13.8333 8.50016C13.8333 9.88683 13.2999 11.1468 12.4333 12.0935Z",
    fill: "#142C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_471_581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/Planet.44e769e99b3b67aa0a4dac8a735bebe1.svg";
export { ForwardRef as ReactComponent };